/* eslint-disable */
import { MAPPING_TYPE_CONFIG } from '../../../Pages/Cooking/Cooking Recipe/mapping.constants';

const ProductMappingTable = ({
	activeStageMappings = [],
	mappingTypeConfig = MAPPING_TYPE_CONFIG,
}) => {
	if (!mappingTypeConfig?.length) {
		return null;
	}

	return (
		<div className="bg-[#f8fafc] border border-[#e2e8f0] rounded-lg p-3 shadow-sm max-w-sm">
			<div className="pb-2 mb-2 border-b border-[#e2e8f0]">
				<span className="text-[11px] font-bold text-[#1e293b] uppercase tracking-wider">
					T : Production Date
				</span>
			</div>
			<div className='flex flex-col gap-2'>
				{mappingTypeConfig.map((cfg) => {
					const entry = activeStageMappings.find(
						(m) => m?.mappingTypeId === cfg.mappingId
					);
					const mappingValue = entry?.mappingTypeElement
						|| cfg.defaultValue
						|| '—';
					const mappingColor = entry?.mappingTypeElement
						? cfg.color
						: '#380000ff';
					return (
						<div
							key={cfg.mappingId}
							className='flex mr-2 items-center justify-between gap-3 group'
						>
							<div className="flex items-center gap-2">
								<span className="text-[14px] flex items-center justify-center w-5 h-5 bg-white rounded shadow-sm border border-[#f1f5f9]">
									{cfg.icon}
								</span>
								<span className='text-[10px] font-semibold text-[#64748b] whitespace-nowrap'>
									{cfg.label}
								</span>
							</div>
							<span
								className='text-[10px] font-bold px-1.5 py-0.5 rounded bg-white border border-[#f1f5f9] shadow-inner'
								style={{ color: mappingColor }}
							>
								{mappingValue}
							</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ProductMappingTable;
